import React from 'react';
import PropTypes from 'prop-types';

import { IDS } from '../../../../../../constants/ids';
import IconMenu from '../../../../../common/IconMenu';
import PrivacyIcon from '../../../../../PrivacyIcon';
import Icon from '../../../../../Icon';
import { formatDate } from '../../../../utils';
import { downloadFile } from '../../../utils';
import { useMenuItemBuilder } from './useMenuItemBuilder';
import { ACTIVITY_LOG_USER_ACTION_TYPE } from '../../../../constants';
import styles from './index.styl';

const { DOWNLOAD, VIEW } = ACTIVITY_LOG_USER_ACTION_TYPE;

const HealthRecordCard = ({ entity, formatMessage }) => {
  const { createdAt, title, filename, isPrivate, effectiveTime } = entity;
  const {
    shareItems,
    downloadItems,
    openItems,
    anyTypeFileData = {},
    isXmlFormat,
    isTxtFormat,
    isConvertibleToPdfData,
    loggingEvent,
  } = useMenuItemBuilder(formatMessage, entity);

  const optionMenuView = isXmlFormat || isTxtFormat || isConvertibleToPdfData;
  
  const handleViewFile = () => {
    if (!optionMenuView) {
      loggingEvent(VIEW);
      window.open(anyTypeFileData.url, '_blank');
    }
  };

  const handleDownloadFile = () => {
    if (!optionMenuView) {
      loggingEvent(DOWNLOAD);
      downloadFile(
        anyTypeFileData.url,
        anyTypeFileData.extension,
        title,
        anyTypeFileData.mimeType,
      );
    }
  };

  return (
    <div className={styles.root}>
      <div className={styles.leftSideWrapper}>
        <Icon size={32} name="icon-document-black" />
        <div className={styles.contentCard}>
          <div className={styles.title}>
            <div className={styles.titleWrapper}>{title || filename}</div>
            <PrivacyIcon show={isPrivate} className={styles.privacyIcon} />
          </div>
          <div className={styles.date}>
            {formatDate(effectiveTime || createdAt, 'MMM D, Y')}
          </div>
        </div>
      </div>
      <div className={styles.rightSideWrapper}>
        <IconMenu
          id={IDS.PATIENT_PORTAL.TAB_HEALTH_RECORD.VIEW_RECORD}
          icon={{ size: 20, name: 'icon-eye-menu' }}
          position={{ horizontal: 'left', vertical: 'bottom' }}
          items={openItems}
          iconActionMode={!optionMenuView}
          onClick={handleViewFile}
          allScreens
        />
        <IconMenu
          id={IDS.PATIENT_PORTAL.TAB_HEALTH_RECORD.DOWNLOAD_RECORD}
          icon={{ size: 20, name: 'icon-download' }}
          position={{ horizontal: 'left', vertical: 'bottom' }}
          items={downloadItems}
          iconActionMode={!optionMenuView}
          onClick={handleDownloadFile}
          allScreens
        />
        <IconMenu
          id={IDS.PATIENT_PORTAL.TAB_HEALTH_RECORD.SHARE_RECORD}
          icon={{ size: 20, name: 'icon-share' }}
          position={{ horizontal: 'left', vertical: 'bottom' }}
          items={shareItems}
          allScreens
        />
      </div>
    </div>
  );
};

HealthRecordCard.propTypes = {
  entity: PropTypes.object,
  formatMessage: PropTypes.func,
};

export default HealthRecordCard;



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/DataList/Card/HealthRecordCard/index.jsx